import { AIStrategyParams } from '~/store/strategy/types'

export const strategyTypes = {
    1: '网格策略',
    2: '反向网络',
    3: '无线网络'
}
export const strategyStatus = {
    1: '待启动',
    2: '初始化',
    3: '运行中',
    4: '终止',
    6: '运行中',
    8: '已终止'
}
export const StrategyStatusLocaleKey = {
    1: 'strategy_grid_text.strategy_status_text_1', // 待启动
    5: 'strategy_grid_text.strategy_status_text_3', // 运行中
    6: 'strategy_grid_text.overing', // 终止中
    8: 'strategy_grid_text.strategy_status_text_8' // 已终止
}
export const StrategyTypeLocaleKey = {
    1: 'strategy_grid_text.grid_strategy_title',
    11: 'strategy_grid_text.forward_grid', // 业务线+网格类型=币币=正向网格
    12: 'strategy_grid_text.backward_grid', // 币币+反向网格
    101: 'strategy_grid_text.contract_long_grid', // 业务线+网格类型=合约=多头网格
    102: 'strategy_grid_text.contract_short_grid' // 合约+空头网格
}
export const StrategyStopReason = {
    1: 'strategy_grid_text.termination_by_insufficient_balance', //可用资金不足，策略终止
    2: 'strategy_grid_text.manual_termination', //手动终止
    3: 'strategy_grid_text.take_profit_termination', //止盈终止
    4: 'strategy_grid_text.take_stop_termination', //止损终止
    6: 'strategy_grid_text.cancel_to_termination', //撤单终止
    7: 'trade.plan.fail_reason_20003', //下单失败
    8: 'strategy_grid_text.follow_termination', // 跟单终止
    9: 'strategy_grid_text.sub_profit_termination', //订阅止盈终止
    10: 'strategy_grid_text.sub_loss_termination', //订阅止损终止

    11: 'auto_invest.order_fail', //下单连续失败3次终止
    12: 'auto_invest.coin_down' //币对下架终止
}
// 网格价格模式的多语言
export const StrategyModelLocaleKey = {
    1: 'strategy_grid_text.equidistant_interval',
    2: 'strategy_grid_text.equal_interval'
}

export const LineTypes = {
    1: 'discount_subscription_activity.user_spot',
    10: 'contract.list.pair'
}

export const allDCAAndGridStrategyType = {
    1: 'strategy_grid_text.strategy_type_text_1', //  "策略-正向网格"
    2: 'strategy_grid_text.strategy_type_text_2', // "策略-反向网格"
    3: 'strategy_grid_text.contract_long_grid', //"策略-多头网格"
    4: 'strategy_grid_text.contract_short_grid', //"策略-空头网格"
    5: 'dca.rightDCA', //"策略-正向DCA"
    6: 'dca.reverseDCA', //"策略-反向DCA"
    7: 'dca.buyLeader', //"策略-多头DCA"
    8: 'dca.sellLeader', //"策略-空头DCA"
    9: 'auto_invest.spot_title' //"定投策略"
}

/**
 * 太多硬编码了，映射也不好做
 * @type {{}}
 */
export const STRATEGY_ENTITY_KEYS = {
    // 确认参数仅包括以下内容
    STRATEGY_NUM: 'strategyNum',
    UP_LIMIT_PRICE: 'strategyMaxPrice',
    DOWN_LIMIT_PRICE: 'strategyMinPrice',
    TOKEN_BASE_INVEST_AMOUNT: 'tokenBaseInvestAmount',
    TOKEN_QUOTE_INVEST_AMOUNT: 'tokenQuoteInvestAmount',
    STRATEGY_MODEL: 'strategyModel',
    STRATEGY_TRIGGER_PRICE: 'triggerPrice',
    // 提交参数还包括以下内容
    STRATEGY_ATTRIBUTE: 'strategyAttribute',
    STRATEGY_MODEL_GRADE: 'strategyModelGrade',
    STRATEGY_TAKE_PROFIT_PRICE: 'stopProfitPrice',
    STRATEGY_STOP_PRICE: 'stopLossPrice',
    GRID_TYPE: 'gridType',
    INVEST_TOKENS: 'investTokens',
    END_OPERATE: 'endOperate',
    TOKEN_ID: 'tokenId',
    MARGIN_MODE: 'marginMode',
    LEVERAGE: 'leverage'
}

/**
 * 基本策略实体
 */
export function createDefaultStrategy(strategyType = 1) {
    return {
        [STRATEGY_ENTITY_KEYS.STRATEGY_ATTRIBUTE]: 2, // 默认手动创建
        [STRATEGY_ENTITY_KEYS.GRID_TYPE]: strategyType, // 默认正向网格
        [STRATEGY_ENTITY_KEYS.STRATEGY_NUM]: '',
        [STRATEGY_ENTITY_KEYS.UP_LIMIT_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.DOWN_LIMIT_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT]: '',
        [STRATEGY_ENTITY_KEYS.TOKEN_QUOTE_INVEST_AMOUNT]: '',
        [STRATEGY_ENTITY_KEYS.STRATEGY_MODEL]: 1, // 默认等差
        [STRATEGY_ENTITY_KEYS.STRATEGY_TRIGGER_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.STRATEGY_MODEL_GRADE]: 0, // 默认没有开仓限价
        [STRATEGY_ENTITY_KEYS.STRATEGY_TAKE_PROFIT_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.STRATEGY_STOP_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.END_OPERATE]: 1
    }
}

/**
 * 选填项
 * @type {(string)[]}
 */
export const OptionalFields = [
    // STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT,
    STRATEGY_ENTITY_KEYS.STRATEGY_TRIGGER_PRICE,
    STRATEGY_ENTITY_KEYS.STRATEGY_TAKE_PROFIT_PRICE,
    STRATEGY_ENTITY_KEYS.STRATEGY_STOP_PRICE
]

/**
 * 抽取用于确认的策略实体
 * @param param
 * @returns {{}}
 */
export function extractConfirmParam(param) {
    let result = {}
    const requireKeys = [
        STRATEGY_ENTITY_KEYS.STRATEGY_NUM,
        STRATEGY_ENTITY_KEYS.UP_LIMIT_PRICE,
        STRATEGY_ENTITY_KEYS.DOWN_LIMIT_PRICE,
        STRATEGY_ENTITY_KEYS.INVEST_TOKENS,
        STRATEGY_ENTITY_KEYS.STRATEGY_MODEL,
        STRATEGY_ENTITY_KEYS.STRATEGY_TRIGGER_PRICE,
        STRATEGY_ENTITY_KEYS.GRID_TYPE,
        STRATEGY_ENTITY_KEYS.LEVERAGE,
        STRATEGY_ENTITY_KEYS.MARGIN_MODE,
        STRATEGY_ENTITY_KEYS.TOKEN_ID
    ]
    requireKeys.forEach((key) => {
        if (param.hasOwnProperty(key)) {
            result[key] = param[key]
        }
    })
    return result
}

export function createStrategyFromHistory(history, isViadated = true) {
    let result = {
        [STRATEGY_ENTITY_KEYS.STRATEGY_ATTRIBUTE]: 2
    }
    const requireKeys = [
        // 策略平台 - 带入止盈止损金额
        STRATEGY_ENTITY_KEYS.STRATEGY_TAKE_PROFIT_PRICE,
        STRATEGY_ENTITY_KEYS.STRATEGY_STOP_PRICE,
        STRATEGY_ENTITY_KEYS.STRATEGY_NUM,
        STRATEGY_ENTITY_KEYS.UP_LIMIT_PRICE,
        STRATEGY_ENTITY_KEYS.DOWN_LIMIT_PRICE,
        STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT,
        STRATEGY_ENTITY_KEYS.TOKEN_QUOTE_INVEST_AMOUNT,
        STRATEGY_ENTITY_KEYS.STRATEGY_MODEL,
        STRATEGY_ENTITY_KEYS.STRATEGY_TRIGGER_PRICE,
        STRATEGY_ENTITY_KEYS.GRID_TYPE
    ]
    const bitMode = +history[STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT] ? 2 : 1
    const notViadatedHistory = Object.assign(history, result, {
        [STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT]: '',
        [STRATEGY_ENTITY_KEYS.TOKEN_QUOTE_INVEST_AMOUNT]: '',
        bitMode //查看是否有组合币
    })
    if (!isViadated) return notViadatedHistory

    requireKeys.forEach((key) => {
        if (history.hasOwnProperty(key)) {
            result[key] = history[key]
        }
    })
    return result
}

// /**
//  * 默认AI参数，使用时记得处理空的情况
//  */
// export function createDefaultAIParams(): AIStrategyParams {
//     return {
//         downLimitPrice: '',
//         oneGridMaxProfit: '',
//         oneGridMinProfit: '',
//         strategyNum: '',
//         upLimitPrice: '',
//         daysRateProfit: ''
//     }
// }

export function transferAIParamsToNormalStrategy(params) {
    const { DOWN_LIMIT_PRICE, UP_LIMIT_PRICE } = STRATEGY_ENTITY_KEYS
    return {
        [DOWN_LIMIT_PRICE]: params.downLimitPrice,
        [UP_LIMIT_PRICE]: params.upLimitPrice,
        [STRATEGY_ENTITY_KEYS.STRATEGY_NUM]: params.strategyNum
    }
}

/**
 * 业务线
 */
export const BusinessLineEnum = {
    SPOT_BL: 1,
    CONTRACT_BL: 2,
    MIX_CONTRACT_BL: 3, // 废弃
    OPTION_BL: 4,
    OTC_BL: 5,
    FINANCIAL_BL: 6,
    SPOT_MIX_CONTRACT: 7,
    S_USDT_MIX_CONTRACT_BL: 8, // SUSDT混合合约，即USDT专业合约模拟盘，仅支持SUSDT保证金
    S_USD_MIX_CONTRACT_BL: 9, // SUSD混合合约，即混合合约的模拟盘
    USDT_MIX_CONTRACT_BL: 10, // USDT混合合约，即USDT专业合约，仅支持USDT保证金
    USD_MIX_CONTRACT_BL: 11 // USD混合合约，即混合合约
}

/**
 * 业务线的业务类型
 * 和撮合类型不同，每个业务线有自己的instType，用于当前委托等业务线相关的数据
 * @param businessLine
 * @returns {string}
 */
export function getBusinessLineCode(businessLine) {
    switch (businessLine) {
        case BusinessLineEnum.SPOT_BL:
            return 'spbl'
        case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
            return 'umcbl'
        case BusinessLineEnum.USD_MIX_CONTRACT_BL:
            return 'dmcbl'
        default:
            return ''
    }
}

/**
 * 业务线的撮合类型
 * 合约的撮合类型是一样的，没有保证金区分，用于和撮合相关，与业务线无关的数据
 * 如：深度，k线
 * @param businessLine
 * @returns {string}
 */
export function getBusinessLineInstType(businessLine) {
    switch (businessLine) {
        case BusinessLineEnum.SPOT_BL:
            return 'sp'
        case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
        case BusinessLineEnum.USD_MIX_CONTRACT_BL:
            return 'mc'
        default:
            return ''
    }
}

export const BusinessLineToLink = {
    [BusinessLineEnum.S_USDT_MIX_CONTRACT_BL]: 'susdt',
    [BusinessLineEnum.S_USD_MIX_CONTRACT_BL]: 'susd',
    [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'usdt',
    [BusinessLineEnum.USD_MIX_CONTRACT_BL]: 'usd'
}

export const StrategyTypeEnum = {
    DEFAULT: 0,
    POSITIVE_GRID: 1,
    NEGATIVE_GRID: 2
}

export const CommonStrategyTypeLocale = {
    [StrategyTypeEnum.DEFAULT]: 'strategy_grid_text.strategy_trade'
}

/**
 * 币币各种策略的名称
 * @type {{'[StrategyTypeEnum.NEGATIVE_GRID]': string}}
 */
export const SpotStrategyTypeLocale = {
    [StrategyTypeEnum.POSITIVE_GRID]: 'strategy_grid_text.forward_grid',
    [StrategyTypeEnum.NEGATIVE_GRID]: 'strategy_grid_text.backward_grid'
}
export const FutureStrategyTypeLocale = {
    [StrategyTypeEnum.POSITIVE_GRID]: 'strategy_grid_text.contract_long_grid',
    [StrategyTypeEnum.NEGATIVE_GRID]: 'strategy_grid_text.contract_short_grid'
}

/**
 * 获取策略的名称
 * @param businessLine
 * @param strategyType
 * @returns {*}
 */
export function getStrategyTypeLocaleKey(businessLine, strategyType) {
    if (strategyType === 0) {
        return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT]
    } else {
        switch (businessLine) {
            case BusinessLineEnum.SPOT_BL:
                return SpotStrategyTypeLocale[strategyType]
            case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
                return FutureStrategyTypeLocale[strategyType]
            default:
                return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT]
        }
    }
}

export const StrategyCreatorFormTypeEnum = {
    AIForm: '1',
    ManualForm: '2'
}
